export class VerifyItemModel {
  constructor(
    public accepted: boolean,
  ) {}
}
